import Icon from '@/components/Icon/Icon';

export default Icon;
